<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const moment = require('moment');
import { secretPublicKey } from "@/constants/config";

export default {
  async created() {
    const { $route, $router, signInDummy} = this //, signInDummy
    if( $route.params.token !== moment().format("YYYYMMDD") ){
      $router.push({name: 'page-not-authorized'}).then()
     }else{
      signInDummy({
        credential: {
          id: $route.params.id,
          username: $route.params.username,
          secretPublicKey: secretPublicKey,
        },
        vm: this
      }).then()
    }
  },
  computed: {
    ...mapState(['status']),
  },
  methods: {
    ...mapActions(['signInDummy']),
  },
  watch: {
    'status.processing'(val) {
      if(val){
        this.$vs.loading();
      }else{
        this.$vs.loading.close();
      }
    }
  }
};
</script>

<style scoped>
  span.bold{
    color: #000000;
    font-size: 15px;
    font-weight: 600;
  }
</style>
